import { defineStore } from "pinia";

import type { Art } from "@/model/session";
import { useGlobalI18n } from "@/translations/i18n";

import { useBoardsStore } from "./boards";

export const NO_ART = { id: "", name: "" };

interface State {
  arts: Art[];
  current: Art;
}

const { t } = useGlobalI18n();

export const useArtStore = defineStore("art", {
  state: (): State => ({ arts: [], current: NO_ART }),
  getters: {
    isMultiArt: (state) => state.arts.length > 1,
    artById: (state) => {
      return (artId?: Art["id"] | null) => state.arts.find((a) => a.id === artId);
    },
    noArt: () => ({ id: NO_ART.id, name: t("general.noArt") }),
  },
  actions: {
    setArts(arts: Art[]) {
      this.arts = arts;
      this.setCurrent(NO_ART);
    },
    // this should only be called from team store
    setCurrent(art: Art) {
      this.current = art;
      useBoardsStore().updateObjectiveBoardId();
    },
    isCurrentArt(artId?: string) {
      return !this.isMultiArt || artId === this.current.id;
    },
  },
});
